export { default } from './ParkingDetailTable';
export { default as ParkingDetailTable } from './ParkingDetailTable';
export type { SpaceRowData } from './ParkingDetailTable';
